"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIndexedDBAvailable = exports.compose = void 0;
function compose(...fns) {
    return function (x) {
        return fns.reduceRight((result, fn) => fn(result), x);
    };
}
exports.compose = compose;
function isIndexedDBAvailable() {
    return new Promise((resolve) => {
        const databaseName = 'testDatabase';
        const callback = (isAvailable) => () => {
            indexedDB.deleteDatabase(databaseName);
            return resolve(isAvailable);
        };
        const request = indexedDB.open(databaseName);
        request.onsuccess = callback(true);
        request.onerror = callback(false);
    });
}
exports.isIndexedDBAvailable = isIndexedDBAvailable;
//# sourceMappingURL=utils.js.map